const isUnsupportedBrowser =
    document.documentMode && document.documentMode < 11;

const maskText = (text, len, maskChar, isLeading) => {
    if (!len || len <= 0 || !text) {
        return text;
    }

    let maskLen = len;

    if (maskLen > text.length) {
        maskLen = text.length;
    }

    const replaceRegEx = new RegExp(
        isLeading ? `^.{${maskLen}}` : `.{${maskLen}}$`,
        'g',
    );

    return text.replace(replaceRegEx, maskChar.repeat(maskLen));
};

const getDataAttributes = (dataAttributes) => {
    if (!dataAttributes) {
        return {};
    }

    const attrObj = {};
    Object.getOwnPropertyNames(dataAttributes ?? {}).forEach((attr) => {
        attrObj[`data-${attr}`] = dataAttributes[attr];
    });

    return attrObj;
};

const getCSSClasses = (baseCls, cssClasses) => {
    return `${baseCls ?? ''} ${(cssClasses ?? '').split(',').join(' ')}`;
};

const getLocaleText = (obj, locale) => {
    const localeObj = obj ?? {};

    return localeObj[locale] || localeObj.en_US;
};

const getInputValue = (e) => {
    const { target } = e ?? {};
    const { value } = target ?? {};

    return value ? value.trim() : '';
};

const getValueFromTheme = (theme, attributeName) => {
    let themeValue = '';

    if (theme) {
        const { attributes } = theme;

        const attribute = (attributes ?? []).filter((attr) => {
            return attr && attr.key === attributeName;
        });
        themeValue = attribute.length ? attribute[0].value : '';
    }

    return themeValue;
};

const getLogoFromTheme = (theme) => {
    return getValueFromTheme(theme, 'web.masthead.logo.large');
};

const getMastHeadBG = (theme) => {
    return getValueFromTheme(theme, 'web.masthead.bgColor.start');
};

const isUnSupportedBrowser = (loginConfig, isIE11) => {
    const isIE11Supported =
        typeof loginConfig.isIE11Supported === 'undefined'
            ? true
            : loginConfig.isIE11Supported;

    return isUnsupportedBrowser || (isIE11 && !isIE11Supported);
};

export default {};
export {
    maskText,
    getDataAttributes,
    getCSSClasses,
    getLocaleText,
    getInputValue,
    getLogoFromTheme,
    getMastHeadBG,
    isUnSupportedBrowser,
};
